module.exports = __webpack_public_path__ + "img/products_in_box.d8f15082.svg";